/** Placeholder in Theme content → products.product.inventory_*_html strings */
export const INVENTORY_LEVEL_PLACEHOLDER = '{inventory}';
